import { CONSULTATIONS_ENDPOINTS } from '../../../utils/api/endpoints/consultationsEndpoints';
import { ConsultationSummaryCOMResponse } from './useConsultationSummaryCOM.types';

const PREFIX = '[consultationSummaryCOMQuery]';

export const queryConsultationSummaryCOM = async (consultationId: number) => {
  console.log(PREFIX, `Fetching consultation #${consultationId}...`);
  const response = await CONSULTATIONS_ENDPOINTS.consultationSummaryCOM(consultationId);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received consultation #${consultationId}.`);
  return json as ConsultationSummaryCOMResponse;
};
